import { Module } from '@nestjs/common';
import { HsnCodesService } from './hsn-codes.service';
import { HsnCodesController } from './hsn-codes.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { HsnCodes } from './hsn-codes.entity';
import { HsnCodesAdapter } from './dto/hsn-codes.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([HsnCodes]),
    ],
  providers: [HsnCodesService,HsnCodesAdapter,ApplicationExceptionHandler,LogsService],
  controllers: [HsnCodesController],
  exports:[HsnCodesService]
})
export class HsnCodesModule {}
